import React, { createContext, useContext } from 'react';
import { useMarketplaceState, type MarketplaceState } from '../hooks/useMarketplaceState';
import type { Role } from '../types/marketplace';
const MarketplaceContext = createContext<MarketplaceState | null>(null);
interface MarketplaceProviderProps {
  initialRole: Role;
  children: React.ReactNode;
}
export function MarketplaceProvider({
  initialRole,
  children
}: MarketplaceProviderProps) {
  const value = useMarketplaceState(initialRole);
  return <MarketplaceContext.Provider value={value} data-id="element-869" data-mp="1cg7fvv7ypbm9">{children}</MarketplaceContext.Provider>;
}
export function useMarketplace(): MarketplaceState {
  const ctx = useContext(MarketplaceContext);
  if (!ctx) throw new Error('useMarketplace must be used inside MarketplaceProvider');
  return ctx;
}